import { apiContainer, queryBuilder } from './apiContainer'

const SLICE_API_ROOT = '/jobtitles'

const jobtitleApi = apiContainer.injectEndpoints({
  endpoints: build => ({
    listJobTitles: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args)
    })
  }),
  overrideExisting: true
})

export const { useLazyListJobTitlesQuery } = jobtitleApi
